import type { FeatureWithActions, KanbanColumn as KanbanColumnType } from '@/shared/types'
import { KanbanColumn } from './kanban-column'

interface KanbanBoardProps {
  features: FeatureWithActions[]
  onFeatureClick?: (feature: FeatureWithActions) => void
}

const COLUMNS: KanbanColumnType[] = [
  'backlog',
  'scoping',
  'design',
  'development',
  'testing',
  'done',
]

export function KanbanBoard({ features, onFeatureClick }: KanbanBoardProps) {
  // Group features by column
  const featuresByColumn = COLUMNS.reduce(
    (acc, column) => {
      acc[column] = features.filter((f) => f.kanban_column === column)
      return acc
    },
    {} as Record<KanbanColumnType, FeatureWithActions[]>
  )

  return (
    <div className="flex h-full gap-4 overflow-x-auto pb-4">
      {COLUMNS.map((column) => (
        <KanbanColumn
          key={column}
          column={column}
          features={featuresByColumn[column]}
          onFeatureClick={onFeatureClick}
        />
      ))}
    </div>
  )
}
